import './FloatingBubble.less'
import FloatingBubble from './FloatingBubble'
export type { FloatingBubbleProps } from './iFloatingBubble'

export default FloatingBubble
